import './SuperAdminReports.scss'
import {PageTitle} from "../../PageTitle/PageTitle";
import React, {useContext, useMemo} from "react";
import {RoutingTabs} from "../../../Utils/RoutingTabs/RoutingTabs";
import {SuperAdminCompaniesDashboard} from "./CompaniesDashboard/SuperAdminCompaniesDashboard";
import {I18nReactContext} from "../../../contexts/I18nContext";

const tabs = ({i18n}) => [
    {
        label: i18n.translate('superAdmin.reports.tabs.companies'),
        subPath: 'companies',
        element: <SuperAdminCompaniesDashboard/>,
        requiredFeatureFlags: [],
    },

]
export const SuperAdminReports = () => {
    const {i18n} = useContext(I18nReactContext);
    let memoizedTabs = useMemo(() => tabs({i18n}), [i18n]);


    return <div className="Reports MenuPage">
        <PageTitle title={i18n.translate('superAdmin.reports.title')}
                   size="minimized"/>
        <div className="menuInnerPage">
            <div className="ReportsTabWrapper">
                <RoutingTabs tabs={memoizedTabs} baseRoute={'nihol/dashboards'}/>
            </div>
        </div>

    </div>
}